import script from "./BaseBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBadge.vue?vue&type=script&setup=true&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=cc5175a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc5175a0"]])

export default __exports__